import { api } from '@/services';

export default {
  async listarEmpresas({ dispatch, commit }, payload) {
    dispatch('toggleLoading', true, { root: true });

    const params = new URLSearchParams();

    // eslint-disable-next-line no-restricted-syntax
    for (const key of Object.keys(payload)) {
      if (payload[key]) {
        params.append(key, payload[key]);
      }
    }

    const { data: empresas } = await api.get('empresa/listar-agrupado', { params });

    commit('SET_EMPRESAS', empresas.data);
    commit('paginacao/SET_PAGINADOR', empresas, { root: true });

    dispatch('toggleLoading', false, { root: true });
  },
  async getUsuariosComex({ commit }) {
    const response = await api.get('/usuario/comex/usuarios');

    commit('SET_USUARIOS_RESPONSAVEIS_COMEX', response.data);

    return response;
  },
  async fetchUsuariosExecutivos({ commit }) {
    const response = await api.get('usuario/trust/executivos');
    commit('SET_USUARIOS_RESPONSAVEIS_EXECUTIVOS', response.data);
  },
  async getResponsaveis(_, payload) {
    return api.get(`empresa/responsaveis/${payload.codigoPessoa}`);
  },
  async salvarResponsaveis(_, payload) {
    return api.post('empresa/responsaveis/', payload);
  },
  async updateEmpresaLote(_, payload) {
    return api.put('empresa/atualizar-lote/', payload);
  },
  async listarQuestionarios({ dispatch, commit }, filtros) {
    dispatch('toggleLoading', true, { root: true });

    const params = new URLSearchParams();

    const { page, perPage, termo, codigoPessoa } = filtros;

    params.append('page', page);
    params.append('perPage', perPage);
    params.append('termo', termo);
    params.append('codigoPessoa', codigoPessoa);

    const { data: questionarios } = await api.get('empresa/listar-questionarios', { params });

    commit('SET_QUESTIONARIOS', questionarios.data);
    commit('paginacaoModal/SET_PAGINADOR', questionarios, { root: true });

    dispatch('toggleLoading', false, { root: true });
  },
  async listarPerguntas({ dispatch, commit }, filtros) {
    dispatch('toggleLoading', true, { root: true });

    const params = new URLSearchParams();

    const { page, perPage, termo, codigoPessoa } = filtros;

    params.append('page', page);
    params.append('perPage', perPage);
    params.append('termo', termo);
    params.append('codigoPessoa', codigoPessoa);

    const { data: perguntas } = await api.get('empresa/listar-perguntas', { params });

    commit('SET_PERGUNTAS', perguntas.data);
    commit('paginacaoModal/SET_PAGINADOR', perguntas, { root: true });

    dispatch('toggleLoading', false, { root: true });
  },
  filtrarQuestionarios({ commit }, filtros) {
    commit('SET_FILTROS_QUESTIONARIOS', filtros);
  },
  filtrarPerguntas({ commit }, filtros) {
    commit('SET_FILTROS_PERGUNTAS', filtros);
  },
  async filtrar({ commit }, payload) {
    return commit('SET_FILTROS', payload);
  },
  setEmpresaDNA({ commit }, payload) {
    commit('SET_EMPRESA_DNA', payload);
  },
  async fetchEnderecoEmpresa(_, { cnpj }) {
    const { data } = await api.get(`empresa/${cnpj}/endereco-empresa`);

    return data.endereco;
  },
};
